/**
 * Helpers for authenticated API calls from the frontend.
 */
import { supabase } from './supabase';

/**
 * Returns headers object with Bearer token for API requests.
 * Use with fetch: { ...(await getAuthHeaders()), 'Content-Type': 'application/json' }
 * @returns {Promise<Record<string, string>>}
 */
export async function getAuthHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('Your session has expired. Please sign in again.');
  }
  return { Authorization: `Bearer ${session.access_token}` };
}
